import { getCanonicalShortCode, isCanonicalShortCode } from './names';

export type RecentMeetingRecord = {
  roomName: string;
  shortCode: string;
  joinedAt: string;
};
const key = 'meet.recent-rooms.v2';

export function loadRecentMeetings(storage: Storage = localStorage): RecentMeetingRecord[] {
  try {
    const value: unknown = JSON.parse(storage.getItem(key) ?? '[]');
    if (!Array.isArray(value)) return [];
    return value
      .filter(
        (item): item is RecentMeetingRecord =>
          !!item &&
          typeof item.roomName === 'string' &&
          isCanonicalShortCode(item.shortCode) &&
          typeof item.joinedAt === 'string',
      )
      .slice(0, 30);
  } catch {
    return [];
  }
}

export function saveRecentMeeting(
  input: { roomName: string; shortCode?: string | null },
  storage: Storage = localStorage,
) {
  try {
    const roomName = input.roomName.trim();
    const shortCode = getCanonicalShortCode(input.shortCode);
    if (!roomName || !shortCode) return [];
    const next = [
      { roomName, shortCode, joinedAt: new Date().toISOString() },
      ...loadRecentMeetings(storage).filter((item) => item.shortCode !== shortCode),
    ].slice(0, 30);
    storage.setItem(key, JSON.stringify(next));
    return next;
  } catch {
    return [];
  }
}

export function removeRecentMeeting(shortCode: string, storage: Storage = localStorage) {
  try {
    const canonical = getCanonicalShortCode(shortCode);
    if (!canonical) return loadRecentMeetings(storage);
    const next = loadRecentMeetings(storage).filter((item) => item.shortCode !== canonical);
    storage.setItem(key, JSON.stringify(next));
    return next;
  } catch {
    return [];
  }
}
